/**
 * check to see if user has a savings account
 * if not send them to the intro page
 * otherwise send them to the dashboard
 */

import {Injectable} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {NewSpendingAccountService} from "./new-spending-account.service";
import {map} from "rxjs/operators";

@Injectable()
export class HasSpendingAccountGuard implements CanActivate {

  constructor(
    private spendingSvc: NewSpendingAccountService,
    private router: Router,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.spendingSvc.getSpendingAccounts();
    return this.spendingSvc.currentAccountInfo.pipe(
      map(resp => {
        // Case when resp is falsy and URL does not include 'creation'
        if (!resp && !state.url.includes('creation')) {
          return this.router.createUrlTree(['accounts', 'spending', 'creation']);
        }
        // Case when resp is falsy and URL includes 'creation'
        if (!resp) {
          return true;
        }
        // Case when resp is truthy but accountId is falsy, and URL does not include 'creation'
        if (!resp.accountId && !state.url.includes('creation')) {
          return this.router.createUrlTree(['accounts', 'spending', 'creation']);
        }
        // Case when resp is truthy and accountId is truthy
        if (resp.accountId) {
          return true;
        }
        // Default case: Navigate to home
        return this.router.createUrlTree(['home']);
      })
    );

  }

}
